import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
export class UserMaster {
  ID: number = 0;
  SEQ_NO: any;
  CTC_PER_HOUR: number;
  IS_ACTIVE: boolean;
}

@Component({
  selector: 'app-user-list-component',
  templateUrl: './user-list-component.component.html',
  styleUrls: ['./user-list-component.component.css'],
})
export class UserListComponentComponent implements OnInit {
  drawerVisible!: boolean;
  drawerTitle!: string;
  isSpinning = false;
  isOk = true;
  drawerData: UserMaster = new UserMaster();
  public commonFunction: any;
  formTitle = 'Manage Users';
  dataList: any[] = [];
  loadingRecords = false;
  totalRecords = 1;
  pageIndex = 1;
  pageSize = 10;
  sortValue: string = 'desc';
  sortKey: string = 'id';
  searchText: string = '';
  // Number with decimal format
  numberWithDecimal(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (
      charCode === 46 && // Decimal point character code
      event.target.value.includes('.')
    ) {
      return false;
    } else if (
      charCode !== 46 && // Decimal point character code
      charCode > 31 &&
      (charCode < 48 || charCode > 57)
    ) {
      return false;
    }

    return true;
  }
  isVisible = false;
  isConfirmLoading = false;
  handleCancel(): void {
    this.isVisible = false;
    this.APPLICABLE_FROM_DATE = null;
  }

  APPLICABLE_FROM_DATE: any;
  disabledEndDate = (current: Date): boolean => {
    // Get the timestamp of today, set to midnight
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Compare the current date's timestamp with today's timestamp
    return current.getTime() < today.getTime(); // Compare timestamps
  };
  showModal(): void {
    this.isVisible = true; 
  }
  columns: string[][] = [
    ['NAME', 'NAME'],
    ['SEQ_NO', 'SEQ_NO'],
    ['IS_ACTIVE', 'Active'],
    ['CTC_PER_HOUR', 'rate'],
  ];

  drawerClose2!: Function;

  constructor(
    private api: ApiService,
    private message: NzNotificationService,
    public cookie: CookieService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {}

  filterQuery: any;
  SeqDataList = [];
  ResetDataList = [];
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
      this.sortKey = 'SEQ_NO';
      this.sortValue = 'asc';
    }

    this.loadingRecords = true;

    let sort: string = this.sortValue.startsWith('a') ? 'asc' : 'desc';

    let likeQuery = '';
    if (this.searchText) {
      likeQuery = ' AND(';
      this.columns.forEach((column) => {
        likeQuery += ` ${column[0]} like '%${this.searchText}%' OR`;
      });
      likeQuery = likeQuery.slice(0, -2) + ')'; // Remove the trailing 'OR' and close the parentheses
    }

    // API call to get Users data
    this.api
      .getusers(
        // this.pageIndex,
        // this.pageSize,
        0,
        0,
        // 'SEQ_NO',
        this.sortKey,

        sort ,
        likeQuery // pass the correct filter here
      )
      .subscribe(
        (data) => {
          if (data['code'] == 200) {
            this.totalRecords = data['count'];
            this.dataList = data['data'];
            this.SeqDataList = data['data'];

            this.ResetDataList = data['data'];
          } else {
            this.message.error('Something Went Wrong', '');
            this.dataList = [];
            this.SeqDataList = [];
            this.ResetDataList = [];
          }
          this.loadingRecords = false;
        },
        (err) => {
          console.error(err); // Log the error for debugging
          this.message.error('Error fetching data', '');
          this.loadingRecords = false;
        }
      );
  }

  keyup(event: any) {
    if (event.length > 3) {
      let mysearch = event.toLowerCase();

      // Filter dataList based on the search string for both NAME and SEQ_NO
      let newarrayList = this.dataList.filter(
        (data) =>
          data.NAME.toLowerCase().includes(mysearch) ||
          data.SEQ_NO.toString().toLowerCase().includes(mysearch) // Ensuring SEQ_NO is a string
      );

      // Update dataList with the filtered results
      this.dataList = [...newarrayList];
    } else if (event === null || event === '') {
      // Reset dataList when the search input is cleared
      this.dataList = [...this.SeqDataList];
    }
  }

  updateUserrecords: boolean = false;
  usersData = [];
  // Function to check and handle sequence number change

  onSeqNoChange(data: any, index: any, newSeqNo: number) {
    const oldSeqNo = index + 1;


    for (let i = 0; i < this.dataList.length; i++) {
      if (oldSeqNo < newSeqNo) {
        if (
          this.SeqDataList[i].SEQ_NO > oldSeqNo &&
          this.SeqDataList[i].SEQ_NO < newSeqNo
        ) {
          this.SeqDataList[i].SEQ_NO--;
        }
        //
        if (this.SeqDataList[i].SEQ_NO == newSeqNo && i != index) {
          this.SeqDataList[i].SEQ_NO--;
        }
      } else {
        if (
          this.SeqDataList[i].SEQ_NO > newSeqNo &&
          this.SeqDataList[i].SEQ_NO < oldSeqNo
        ) {
          this.SeqDataList[i].SEQ_NO++;
        }
        //
        if (this.SeqDataList[i].SEQ_NO == newSeqNo && i != index) {
          this.SeqDataList[i].SEQ_NO++;
        }
      }
    }

    // Sort the list by SEQ_NO to maintain order
    this.SeqDataList.sort((a, b) => a.SEQ_NO - b.SEQ_NO);

    this.dataList = [...this.SeqDataList];
    // Log updated data
    //
  }

  ResetData() {
    this.search(true);
  }
  Senddata=[]
  UpdateUserData(): void {
    // Check if the User data is empty
    this.isConfirmLoading =true;
    this.usersData = this.dataList;
    if (!this.usersData || this.usersData.length === 0) {
      this.message.error('User list is empty', '');
      return;
    }

    this.loadingRecords = true;

    for (let i = 0; i < this.usersData.length; i++) {
      this.Senddata[i] = {}; // Initialize the element if not already done
      this.Senddata[i]['USER_ID'] = this.usersData[i]['ID'];
      this.Senddata[i]['CTC_PER_HOUR'] = this.usersData[i]['CTC_PER_HOUR'];
  
      // Fix these fields if the dates should be different from ID
      this.Senddata[i]['APPLICABLE_FROM_DATE'] = this.datePipe.transform(this.APPLICABLE_FROM_DATE,'yyyy-MM-dd')   
      // this.Senddata[i]['APPLICABLE_TO_DATE'] = this.usersData[i]['END_DATE'] || this.usersData[i]['ID']; // Example for handling dates
  
      this.Senddata[i]['STATUS'] = this.usersData[i]['IS_ACTIVE'];
  }
    console.log(this.Senddata);
    
     
    const dataToSave = {
      data: this.Senddata,
      CLIENT_ID:1
    };

    this.updateUserrecords = true;
    this.api.updateUserData(dataToSave).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.message.success('User data updated successfully', '');
          this.search(true);
          this.APPLICABLE_FROM_DATE = null;
          this.isVisible = false;
          this.isConfirmLoading = false;
        } else {
          this.message.error('Failed to update user data', '');
        }
        this.loadingRecords = false;
        this.updateUserrecords = false;
      },
      (error) => {
        console.error('Error:', error);
        this.message.error('An error occurred while updating user data', '');
        this.loadingRecords = false;
        this.updateUserrecords = false;
      }
    );
  }

  
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'SEQ_NO';
    const sortOrder = (currentSort && currentSort.value) || 'asc';

    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.search();
  }


}
